<!-- BulletNews.vue -->
<script setup lang="ts">
  import { parseISO } from 'date-fns'
  import { toZonedTime, format as formatTz } from 'date-fns-tz'
  import { INewsProps } from '@/types'
  import { Typography } from '@components/index'

  const props = defineProps<INewsProps>()

  const formatDate = (dateString: string, dateFormat: string, timeZoneOffset = 0) => {
    if (!dateString) return ''
    const dateWithTime = parseISO(dateString)
    const timeZone = `Etc/GMT${timeZoneOffset > 0 ? '-' : '+'}${Math.abs(timeZoneOffset)}`
    const adjustedDate = toZonedTime(dateWithTime, timeZone)
    const formattedDate = formatTz(adjustedDate, dateFormat, { timeZone })
    return formattedDate
  }
</script>

<template>
  <div class="new-frame">
    <div class="frame-title">
      <Typography variant="news-title">
        {{ props.title }}
      </Typography>
      <Typography variant="subtitle">
        {{ formatDate(props.createdAt, 'dd/MM/yyyy', -3) }}
      </Typography>
    </div>
    <div class="frame-description">
      <div
        class="newsContent"
        v-html="props.content"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
  .new-frame {
    flex: 1;
    background-color: #2d3034;
    border-radius: 9px;
    padding: 30px;
    margin-top: 12px;
    margin-bottom: 12px;
  }

  .new-frame .frame-title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .new-frame .frame-description {
    display: flex;
    flex-direction: column;
    padding-top: 6px;
  }

  .newsContent :deep(p:last-of-type) {
    margin-block-end: 0px;
  }
</style>
